import React from 'react';
import { Button, Modal } from 'antd';

function InfoModal({ visible, setVisible, content = [] }) {
  const onCancel = () => {
    setVisible(false);
  };

  return (
    <Modal
      visible={visible}
      title="Changelog"
      onCancel={onCancel}
      footer={[
        <Button key="Close" onClick={onCancel}>
          Close
        </Button>,
      ]}
    >
      {content && content.map((c, idx) => <div key={idx}>{c}</div>)}
    </Modal>
  );
}

export default InfoModal;
